import React, { Component } from 'react';
import IconButton from '@material-ui/core/IconButton';
import cx from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import {
  genKey,
  Modifier,
  EditorState,
  ContentBlock,
  CharacterMetadata,
  BlockMapBuilder,
} from 'draft-js';
import { List, Repeat } from 'immutable';
import PropTypes from 'prop-types';
const insertAtomicBlock = (
  editorState,
  type,
  entityJson,
  character,
  addCaption = false,
) => {
  let contentState = editorState.getCurrentContent();
  let selectionState = editorState.getSelection();
  const blockKey = selectionState.getFocusKey();
  const block = contentState.getBlockForKey(blockKey);
  const offset = block.getText().length;
  contentState = Modifier.splitBlock(
    contentState,
    selectionState.set('focusOffset', offset).set('anchorOffset', offset),
  );
  selectionState = contentState.getSelectionAfter();

  const entityType = entityJson ? entityJson.type : null;
  const entityMutability = entityJson ? entityJson.mutability : null;
  const entityData = entityJson ? entityJson.data : null;
  const contentStateWithEntity = entityJson
    ? contentState.createEntity(entityType, entityMutability, entityData)
    : null;

  const asAtomicBlock = Modifier.setBlockType(
    contentStateWithEntity || contentState,
    selectionState,
    type,
  );

  const entityKey = entityJson ? contentState.getLastCreatedEntityKey() : null;
  const charData = CharacterMetadata.create(
    entityKey ? { entity: entityKey } : {},
  );

  const fragmentArray = [
    new ContentBlock({
      key: genKey(),
      type,
      text: character,
      characterList: List(Repeat(charData, character.length)),
    }),
    new ContentBlock({
      key: genKey(),
      type: addCaption ? 'caption' : 'unstyled',
      text: '',
      characterList: List(),
    }),
  ];

  const fragment = BlockMapBuilder.createFromArray(fragmentArray);

  const withAtomicBlock = Modifier.replaceWithFragment(
    asAtomicBlock,
    selectionState,
    fragment,
  );

  const newContent = withAtomicBlock.merge({
    selectionBefore: selectionState,
    selectionAfter: withAtomicBlock.getSelectionAfter().set('hasFocus', true),
  });

  return EditorState.push(editorState, newContent, 'insert-fragment');
};

const styles = theme => ({
  root: {
    color: 'white',
  },
});

const createAtomicBlockButton = ({
  blockType,
  entityJson,
  addCaption,
  children,
  help,
}) =>
  @withStyles(styles)
  class AtomicBlockButton extends Component {
    static help = help;
    static serviceName = 'atomicButton';
    static blockType = blockType;
    static displayName = `AtomicBlockButton-${blockType}`;

    static defaultProps = {
      onToggleMenu: () => {},
    };

    static propTypes = {
      setEditorState: PropTypes.func.isRequired,
      editorState: PropTypes.object.isRequired,
      onToggleMenu: PropTypes.func,
    };

    preventDefault(e) {
      e.preventDefault();
    }

    toggleStyle = e => {
      e.preventDefault();
      this.props.setEditorState(
        insertAtomicBlock(
          this.props.editorState,
          blockType,
          entityJson,
          ' ',
          addCaption,
        ),
      );
      this.props.onToggleMenu(e);
    };

    render() {
      const {
        theme,
        classes,
        className,
        setEditorState,
        onOverrideContent,
        editorState,
        onToggleMenu,
        ...rest
      } = this.props;
      return (
        <div
          className={classes.root}
          onMouseDown={this.preventDefault}
          {...rest}
        >
          <IconButton
            color={this.isActive ? 'primary' : 'inherit'}
            onClick={this.toggleStyle}
          >
            {children}
          </IconButton>
        </div>
      );
    }
  };

export default createAtomicBlockButton;
